module.exports = __webpack_public_path__ + "static/media/insert_shape_passo1.5be1723f.png";